import { RecoverAccountPage } from '@/containers';

export const RecoverAccount = () => {
  return <RecoverAccountPage />;
};
